import { Injectable } from '@angular/core';
import { Howl, Howler } from 'howler';
@Injectable({
  providedIn: 'root'
})

export class SoundService {
  private music: Howl;
  private soundEffect: Howl;

  private songs: Map<Music, Howl> = new Map();
  private soundFX: Map<SoundFX, Howl> = new Map();

  constructor() {
    Howler.volume(0.5);
    Object.keys(Music).filter(key => !isNaN(Number(key))).map(value => Music.getFromValue(Number(value))).forEach(song => {
      const howl = new Howl({
        // TODO: set correct options here.
      });

      this.songs.set(song, howl);
    });
  }
}

export enum Music {
  FULL_TEMPEST, PANJSHIR, THE_QUEEN, THE_HANDSOME_PRINCE

}

// May need to convert these to sound sprites. Not a bad idea.
export enum SoundFX {
  SHUFFLE, DEAL, SELECTION, ELIMINATED, TARGETED
}

export namespace Music {
  export function getPath(song: Music){
    const base = `assets/sounds/music/`;
    const ext = `.mp3`;
    return `${base}${Music.getName(song)}${ext}`;
  }

  export function getName(song: Music) {
    switch (song) {
      case Music.FULL_TEMPEST: return 'full-tempest';
      case Music.PANJSHIR: return 'panjshir';
      case Music.THE_HANDSOME_PRINCE: return 'the-handsome-prince';
      case Music.THE_QUEEN: return 'the-queen';
    }
  }

  export function getFromValue(key: number) {
    switch (key) {
      case 0: return Music.FULL_TEMPEST;
      case 1: return Music.PANJSHIR;
      case 2: return Music.THE_HANDSOME_PRINCE;
      case 3: return Music.THE_QUEEN;
    }
  }
}
